import { isUfeEnvProduction } from '@ufe/shared/constants/env';
import printTimestamp from '@ufe/shared/utils/timestamp';

const logError = (error = {}, additionalInformation = { source: 'Unknown' }) => {
    const { isNodeRender, pagePath: path, renderQueryParams: queryParams, serverErrors } = Sephora;
    const { message = '', name = '', stack = '' } = error;

    if (isNodeRender) {
        if (!isUfeEnvProduction && serverErrors) {
            serverErrors.push({
                message,
                name,
                path,
                queryParams,
                stack,
                ...additionalInformation
            });
        }
    }

    const timestamp = printTimestamp();
    const logEntry = `${timestamp} [URL: ${queryParams?.urlPath ?? ''}] [template: ${path}] [${additionalInformation.source}] ${stack}`;
    // eslint-disable-next-line no-console
    console.error(logEntry);
};

export default logError;
